<template>
    <v-sheet>
        <FailureMaster/>
    </v-sheet>
</template>

<script>
import FailureMaster from './../components/FailureMaster';
export default {
    name: "FailureMasterView",
    components: { FailureMaster}
}
</script>

<style>

</style>